import styles from './TabsHeader.module.css';
import React from 'react';

const TabsHeader = ({ children }) => {
  return <h1 className={styles.messaging}>{children}</h1>;
};

export default TabsHeader;
